import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { ArrowUpRight } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Insights() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`${API}/articles`).then(({ data }) => setItems(data)).catch(() => {}).finally(() => setLoading(false));
  }, []);

  return (
    <div data-testid="insights-page" className="bg-[#0B0F0E]">
      <section className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-16 pt-20 md:pt-28 pb-16">
        <div className="overline"><span className="h-line" />Insights</div>
        <h1 className="font-display text-[#F4EFE6] text-6xl md:text-7xl lg:text-[5.5rem] mt-7 leading-[0.95] max-w-4xl">
          Plain-English thinking on <span className="italic-gold">strategic land.</span>
        </h1>
        <p className="text-[#9BA39B] text-lg max-w-3xl mt-9 leading-relaxed">
          Articles, market notes and policy explainers — written for landowners, by people who do this every day.
        </p>
      </section>

      <section className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-16 pb-28">
        {loading ? (
          <div className="text-[#9BA39B] py-10">Loading...</div>
        ) : items.length === 0 ? (
          <div data-testid="insights-empty" className="border border-[#F4EFE6]/10 bg-[#11171A] p-16 text-center text-[#9BA39B]">
            No articles published yet. Check back soon.
          </div>
        ) : (
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {items.map((a) => (
              <Link key={a.id} data-testid={`article-card-${a.slug}`} to={`/insights/${a.slug}`} className="group">
                {a.cover_image ? (
                  <div className="overflow-hidden">
                    <img src={a.cover_image} alt={a.title} className="w-full h-56 object-cover transition-transform duration-700 group-hover:scale-105" />
                  </div>
                ) : (
                  <div className="h-56 bg-gradient-to-br from-[#11171A] to-[#0B0F0E] border border-[#F4EFE6]/10 flex items-center justify-center">
                    <span className="font-display text-[#C9A24B] text-4xl italic">Upsurge</span>
                  </div>
                )}
                <div className="mt-5">
                  {a.tag && <div className="text-[10px] tracking-[0.24em] uppercase text-[#C9A24B] font-semibold">{a.tag}</div>}
                  <h3 className="font-display text-2xl md:text-3xl text-[#F4EFE6] mt-2 leading-tight group-hover:text-[#C9A24B] transition-colors">{a.title}</h3>
                  {a.excerpt && <p className="text-[#9BA39B] text-sm mt-3 leading-relaxed line-clamp-3">{a.excerpt}</p>}
                  <div className="text-[11px] text-[#9BA39B] mt-4 flex items-center gap-2">
                    <span>{new Date(a.created_at).toLocaleDateString("en-GB", { day: "numeric", month: "long", year: "numeric" })}</span>
                    <ArrowUpRight size={14} className="text-[#C9A24B]" />
                  </div>
                </div>
              </Link>
            ))}
          </div>
        )}
      </section>
    </div>
  );
}
